import Model, { attr } from '@ember-data/model';

export default class AbstractPhotoPageModel extends Model {
  @attr('boolean') declare enabled: boolean;
  @attr('boolean', { defaultValue: false }) declare useExistingPhoto: boolean;
}
